import { z } from "zod";

import { isShallowEqual } from "~/tools/is-shallow-equal";
import { useHandler } from "~/tools/use-handler";
import { useMemo } from "~/tools/use-memo";

import { matchQueryKey } from "./match-query-key";
import { useIsFetching, useQueryClient } from "./react-query";

export function useRefetchQueriesInNamespace(
	namespace: ReadonlyArray<string>,
): [isFetching: boolean, refetch: VoidFunction] {
	const queryClient = useQueryClient();

	const queryMatcher = useMemo(
		() =>
			matchQueryKey({
				namespace: z
					.array(z.string())
					.refine((fragments) => namespace.every((fragment, index) => fragments[index] === fragment)),
			}),
		[namespace],
		[isShallowEqual],
	);

	const fetchingCount = useIsFetching({
		predicate: ({ queryKey, state }) => state.data != null && state.isFetching && queryMatcher(queryKey),
	});

	const refetch = useHandler(() => {
		void queryClient.invalidateQueries({
			predicate: ({ queryKey }) => queryMatcher(queryKey),
		});
	});

	return [fetchingCount > 0, refetch];
}
